import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as Icon } from 'assets/Icons/24px/settings.svg';

function ToolsAnalyticsIcon(props: SvgIconProps) {
  return (
    <SvgIcon component={Icon} viewBox="0 0 50 50" {...props} />
  );
}

export default ToolsAnalyticsIcon;